import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/lib/utils";

export type ColProps = React.ComponentProps<"div"> & {
  asChild?: boolean;
};

export const Col = React.forwardRef<HTMLDivElement, ColProps>(
  ({ className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";
    return (
      <Comp ref={ref} className={cn("flex flex-col", className)} {...props} />
    );
  },
);
Col.displayName = "Col";
